import React from "react";
import { Box, Typography } from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import { useTranslation } from "react-i18next";
import ChiStyledButton from "./StyledButton";
import { COLORS } from "constants/colors";

function ChiEpisodeEmpty({ onClick }) {
  const [t, i18n] = useTranslation(["chi"]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <SearchOffIcon sx={{ fontSize: "100px", color: COLORS.TEXT_WHITE }} />
      <Typography
        variant="h6"
        sx={{
          marginTop: "16px",
          color: COLORS.TEXT_WHITE,
          fontWeight: "bold",
          fontFamily: '"Noto Serif JP", serif',
          fontSize: "16px",
          textAlign: "center",
        }}
      >
        {t("chi:error.episode_empty")}
      </Typography>
      <ChiStyledButton
        variant="contained"
        onClick={onClick}
        sx={{
          mt: 4,
          mb: 10,
        }}
      >
        {t("chi:button.purchase_ticket")}
      </ChiStyledButton>
    </Box>
  );
}

export default ChiEpisodeEmpty;
